import Controller, { OnClose, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { AuthenticationService, HttpService, JWTToken } from '@philips-internal/oswald-ui-core/lib/services';
import { Inject } from '@odinjs/odin';
import BaseController from '../BaseController';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import TokenConstants from '../../constants/TokenConstants';
import { PatientTermServiceApi } from '@philips-emr/patient-components/src';
import { FetchAPI } from '@philips-internal/oswald-ui-components';
import { APPLICATION_ROUTES } from '../../constants/application-routes';
import { OnSubmitTermUse } from '../../app/events';

/*
interface TermsUse {
  nrSeqTermo: number;
}*/

@Controller({ component: 'assign-privacy-modal', fragment: 'assign-privacy-modal' })
class AssignPrivacyController extends BaseController {

  @Inject('privacy-fetch')
    fetchTermoUso!: FetchAPI;

  @Inject('patient.privacy.notice')
    checkTerm!: PatientTermServiceApi;

  @OnMount({ target: ['assign-privacy-modal'] })
  onMount(): void {
    const nrSeqTermo = this.getHistoryRouteParam<string>('nrSeqTermo');
    this.context.set({ nrSeqTermo });
    const nrSeqValid = nrSeqTermo !== 'undefined';
    this.checkTerm.setEnabled(nrSeqValid);
    if (nrSeqValid) {
      this.fetchTermoUso.setParameters({ nrSeqTermo });
      this.fetchTermoUso.forceFetch();
    }
  }

  @OnClose({ target: ['assign-privacy-modal'] })
  onclose(): void {
    AuthenticationService.logout();
  }

  @OnSubmitTermUse('patient.privacy.notice')
  onSubmitTermUse(): void {
    const nrSeqTermo = this.getHistoryRouteParam<string>('nrSeqTermo');
    if (nrSeqTermo !== 'undefined') {
      HttpService.put(APPLICATION_ENDPOINTS.UPDATE_PRIVACY, { nrSeqTermo }).then(() => {
        // If the consent term is used, this line must be uncommented.
        // this.checkConsentTerm();

        // Remove this code block if the consent term is used.
        this.pushUserToDashboard();
      });
    }
  }

  /*private checkConsentTerm(): void {
    HttpService.get(APPLICATION_ENDPOINTS.CHECK_TERMS_OF_USE, { termType: TermsOfUseType.TERM_OF_CONSENT }).then(respCheckAviso => {
      const termConsent = respCheckAviso.body as TermsUse;
      if (!termConsent.nrSeqTermo) {
        HttpService.get(APPLICATION_ENDPOINTS.GET_TERMS_OF_USE_SEQUENCE, { termType: TermsOfUseType.TERM_OF_CONSENT })
          .then(resp => {
            const nrSeqTermo = (resp.body as TermsUse).nrSeqTermo;
            this.historyService.push(APPLICATION_ROUTES.ASSIGN_TERMS_OF_USE, { nrSeqTermo, termType: TermsOfUseType.TERM_OF_CONSENT });
          })
      } else {
        this.pushUserToDashboard();
      }
    });
  }*/

  private pushUserToDashboard(): void {
    const token = AuthenticationService.getJWTToken() as JWTToken;
    const patientId: string = token.claims[TokenConstants.PATIENT_ID] as string;
    const params = { patientId };
    this.historyService.push(APPLICATION_ROUTES.HOME_DASHBOARD, params);
  }
}

export default AssignPrivacyController;
